<template>
  <div class="change-driver-role main">
    <!-- <p class="header has-text-link" @click="close">
      <i class="fa fa-chevron-left" style="margin-right: 4px" />
      <i>Change Driver Role</i>
    </p> -->
    <div class="field is-grouped">
      <span
        class="button is-medium is-white is-rounded"
        style="padding: 12px"
        @click="close"
      >
        <i class="fa fa-chevron-left fa-lg" />
      </span>
      <div class="control has-icons-right search is-expanded">
        <span
          class="icon is-right"
          style="pointer-events: initial; font-size: 1.3em"
          v-show="searchTerm"
          @click="clearSearch"
        >
          <i class="fa fa-times-circle" />
        </span>
        <input
          ref="input"
          class="input is-rounded is-medium"
          type="text"
          v-model="searchVal"
          :placeholder="searchPlaceholder"
          @keyup="search($event)"
          @focus="search($event)"
          @blur="clearSearch"
        />
      </div>
    </div>
    <div v-if="searchResult.length > 0" class="list is-hoverable search-result">
      <span
        v-for="s in searchResult"
        v-ripple
        class="list-item"
        :key="s.key + s.value"
        @click="chooseBusiness(s.value)"
        >{{ s.key }}
        <i
          v-if="s.value === role.business_id"
          class="fa fa-lock is-pulled-right"
          style="color: pink"
        />
      </span>
    </div>
    <div v-show="showSearching" class="list search-result">
      <span class="list-item">
        <i class="fa fa-spinner fa-spin" />
      </span>
    </div>
    <div v-show="noResults && !showSearching" class="list search-result">
      <span class="list-item is-italic">
        <i>{{ $t("home2.no-results-for") }} "{{ searchTerm }}"</i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    role: Object,
  },
  data() {
    return {
      searchPlaceholder: "Change Driver Business", //"Search business name",
      isShowMobile: false,
      isSearching: false,
      searchResult: [],
      noResults: false,
      searchVal: null,
      searchTerm: null,
      lastSearch: null, // store last search when searchVal/searchTerm clear
    };
  },
  computed: {
    showSearching() {
      if (this.searchResult.length > 0) return false;
      return this.isSearching;
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.input.focus());
  },
  methods: {
    close() {
      this.$emit("close");
    },
    chooseBusiness(businessID) {
      console.log("chooseBusiness", businessID);
      this.changeDriverRole(businessID);
    },
    changeDriverRole(businessID) {
      var payload = {
        id: this.role.id,
        business_id: businessID,
      };
      var loader = this.loadingDots("navy");
      this.$store
        .dispatch("changeDriverRole", payload)
        .then((res) => {
          console.log("changeDriverRole", res.data);
          this.updateRoles(true);
          this.$emit("changed");
          this.close();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    clearSearch() {
      this.searchVal = null;
      this.searchTerm = null;
      this.noResults = false;
      setTimeout(() => (this.searchResult = []), 300);
    },
    search(e) {
      var text = e.target.value; //   var text = this.searchVal;
      this.searchTerm = text; // a hack for mobile...
      this.lastSearch = text;
      console.log("search", text);
      if (text.length < 3) {
        this.searchResult = [];
        this.isSearching = false;
        this.noResults = false;
        return;
      }
      this.isSearching = true;
      // change to a business + workflow autocomplete search endpoint
      this.$store
        .dispatch("autocompleteSearch", text)
        .then((res) => {
          if (res.data) {
            console.log("search", res.data);
            if (res.data.businesses) {
              this.searchResult = res.data.businesses;
              this.noResults = false;
            } else {
              this.searchResult = [];
              this.noResults = true;
            }
          } else {
            this.searchResult = [];
            this.noResults = true;
          }
        })
        .catch((err) => console.error("searchAutocomplete", err))
        .finally(() => (this.isSearching = false));
    },
  },
};
</script>

<style scoped>
.main {
  position: relative;
  /* padding-bottom: 10px; */
  width: 100%;
}
.header {
  text-align: left;
  font-size: 1.1em;
  padding-left: 4px;
  padding-bottom: 3px;
}
.list {
  position: fixed;
  background-color: lightgoldenrodyellow;
  z-index: 2;
  width: calc(100vw - 36px);
  margin-left: -2px;
  margin-bottom: 0;
  margin-top: -10px;
}
.search-result {
  text-align: left;
}
</style>